import { CSSProperties } from 'react';

export function PhantomLogo({ size = 16, style }: { size?: number; style?: CSSProperties }) {
	return (
		<svg
			width={size}
			height={size}
			style={style}
			viewBox="0 0 34 34"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M49.4949 16.4983V11.3943H52.2354C53.9703 11.3943 55.0263 12.3749 55.0263 13.9589C55.0263 15.4926 53.9703 16.4983 52.2354 16.4983H49.4949ZM52.6629 19.4903C56.1829 19.4903 58.5211 17.1771 58.5211 13.9337C58.5211 10.7154 56.1829 8.37714 52.6629 8.37714H46V26.2034H49.4697V19.4903H52.6629Z"
				fill="white"
			/>
			<path
				d="M64.1685 18.9371C64.2439 17.5794 65.0736 16.5234 66.4816 16.5234C68.0907 16.5234 68.7696 17.6046 68.7696 18.9874V26.2034H72.1136V18.4091C72.1136 15.6937 70.6553 13.5063 67.5125 13.5063C66.3307 13.5063 64.973 13.9086 64.1685 14.864V8H60.8245V26.2034H64.1685V18.9371Z"
				fill="white"
			/>
			<path
				d="M74.7532 22.8343C74.7532 24.7703 76.3624 26.5554 79.0024 26.5554C80.8378 26.5554 82.0195 25.7006 82.6481 24.72C82.6481 25.1977 82.6984 25.8766 82.7738 26.2034H85.8412C85.7658 25.776 85.6904 24.896 85.6904 24.2423V18.1577C85.6904 15.6686 84.2321 13.456 80.3098 13.456C76.9909 13.456 75.2058 15.5931 75.0046 17.5291L77.9715 18.1577C78.0721 17.0766 78.8766 16.1463 80.3349 16.1463C81.7429 16.1463 82.4218 16.8754 82.4218 17.7554C82.4218 18.1829 82.1955 18.5349 81.4915 18.6354L78.4492 19.088C76.3875 19.3897 74.7532 20.6217 74.7532 22.8343ZM79.7064 24.0663C78.6252 24.0663 78.0972 23.3623 78.0972 22.6331C78.0972 21.6777 78.7761 21.2 79.6309 21.0743L82.4218 20.6469V21.2C82.4218 23.3874 81.1144 24.0663 79.7064 24.0663Z"
				fill="white"
			/>
			<path
				d="M92.4051 19.088C92.4051 17.6549 93.2599 16.5234 94.7182 16.5234C96.3274 16.5234 97.0062 17.6046 97.0062 18.9874V26.2034H100.35V18.4091C100.35 15.6937 98.9422 13.5063 95.8748 13.5063C94.5422 13.5063 93.0588 14.0846 92.3045 15.3669V13.8331H89.0611V26.2034H92.4051V19.088Z"
				fill="white"
			/>
			<path
				d="M107.868 10.1371H104.85V11.872C104.85 12.9783 104.247 13.8331 102.94 13.8331H102.311V16.8H104.549V22.5577C104.549 24.9463 106.057 26.3794 108.471 26.3794C109.452 26.3794 110.055 26.2034 110.357 26.0777V23.312C110.181 23.3623 109.728 23.4126 109.326 23.4126C108.37 23.4126 107.868 23.0606 107.868 21.9794V16.8H110.357V13.8331H107.868V10.1371Z"
				fill="white"
			/>
			<path
				d="M118.631 23.5383C116.997 23.5383 115.488 22.3314 115.488 20.0183C115.488 17.68 116.997 16.4983 118.631 16.4983C120.265 16.4983 121.774 17.68 121.774 20.0183C121.774 22.3566 120.265 23.5383 118.631 23.5383ZM118.631 13.456C114.935 13.456 112.144 16.1966 112.144 20.0183C112.144 23.8149 114.935 26.5806 118.631 26.5806C122.327 26.5806 125.118 23.8149 125.118 20.0183C125.118 16.1966 122.327 13.456 118.631 13.456Z"
				fill="white"
			/>
			<path
				d="M131.101 26.2034V18.9623C131.101 17.6046 131.956 16.5234 133.415 16.5234C134.923 16.5234 135.602 17.5291 135.602 18.8617V26.2034H138.921V18.9623C138.921 17.6297 139.776 16.5234 141.209 16.5234C142.743 16.5234 143.396 17.5291 143.396 18.8617V26.2034H146.64V18.1829C146.64 14.864 144.452 13.4811 142.164 13.4811C140.53 13.4811 139.223 14.0343 138.242 15.5429C137.613 14.2103 136.256 13.4811 134.571 13.4811C133.214 13.4811 131.63 14.1349 130.951 15.3417V13.8331H127.757V26.2034H131.101Z"
				fill="white"
			/>
			<circle cx="17" cy="17" r="17" fill="url(#paint0_linear)" />
			<path
				d="M29.1702 17.2071H26.1733C26.1733 11.0997 21.205 6.14893 15.0758 6.14893C9.02255 6.14893 4.10117 10.9785 3.98072 16.9813C3.85611 23.1863 9.69824 28.5745 15.9261 28.5745H16.7095C22.2001 28.5745 29.5592 24.2916 30.709 19.0732C30.9213 18.1113 30.1588 17.2071 29.1702 17.2071ZM10.6223 17.4792C10.6223 18.2959 9.95192 18.9639 9.13229 18.9639C8.31265 18.9639 7.64231 18.2956 7.64231 17.4792V15.0773C7.64231 14.2606 8.31265 13.5926 9.13229 13.5926C9.95192 13.5926 10.6223 14.2606 10.6223 15.0773V17.4792ZM15.7961 17.4792C15.7961 18.2959 15.1258 18.9639 14.3062 18.9639C13.4865 18.9639 12.8162 18.2956 12.8162 17.4792V15.0773C12.8162 14.2606 13.4868 13.5926 14.3062 13.5926C15.1258 13.5926 15.7961 14.2606 15.7961 15.0773V17.4792Z"
				fill="url(#paint1_linear)"
			/>
			<defs>
				<linearGradient id="paint0_linear" x1="17" y1="0" x2="17" y2="34" gradientUnits="userSpaceOnUse">
					<stop stopColor="#534BB1" />
					<stop offset="1" stopColor="#551BF9" />
				</linearGradient>
				<linearGradient
					id="paint1_linear"
					x1="17.3617"
					y1="6.14893"
					x2="17.3617"
					y2="28.5745"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset="1" stopColor="white" stopOpacity="0.82" />
				</linearGradient>
			</defs>
		</svg>
	);
}
